var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlienFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 595.3",
    style: {
      enableBackground: "new 0 0 595.3 595.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FDE65D;}\r\n\t.st1{fill:#F1D65C;}\r\n\t.st2{fill:none;stroke:#221F20;stroke-width:11.2129;stroke-miterlimit:10;}\r\n\t.st3{fill:#221F20;}\r\n\t.st4{fill:#FFFEF9;}\r\n\t.st5{fill:#30A9E1;}\r\n\t.st6{fill:#E5262B;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#E0C345;}\r\n\t.st9{fill:url(#SVGID_1_);}\r\n\t.st10{fill:url(#SVGID_00000178891509139432369750000008588138164747431323_);}\r\n\t.st11{fill:#35A7DF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.6,136c0,0,1.7-67.4-44.4-80.7c0,0-39-15.5-66.1,44c0,0-11.7-0.3-17,9.2c0,0-7.9,14.2,5.7,21.8 c13.6,7.6,26.1-4.1,26.8-16.1c0,0,18.7-40.2,34.5-37.3c15.8,3,31.1,17.4,26.7,67.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.2,136.8c0,0,149.3-32.4,242.9,91.3c0,0,50.6,98,31.1,169.8L202.2,136.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,204.5c0,0-53.4,23.4-77.8,121.2c0,0-32,150.9,103.3,193.4c0,0,182.1,54,288.8-4.5c0,0,89-76,0-222.3 C395.5,292.3,282.8,122.6,81.1,204.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.6,412.9c0,0,0.1,11.4-17.8,11.5c0,0-12,0.1-24.1-6.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346.7,388c24.5-40.4,19.5-87.9-11.2-106.1c-30.6-18.2-75.3-0.3-99.8,40c-24.5,40.4-19.5,87.9,11.2,106.1 C277.6,446.3,322.2,428.4,346.7,388z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.7,428.2c21.1,0,38.2-37.3,38.2-83.3c0-46-17.1-83.3-38.2-83.3c-21.1,0-38.2,37.3-38.2,83.3 C30.5,390.9,47.6,428.2,68.7,428.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.8,343.6c10-9.9,12.2-23.8,4.9-31c-7.3-7.2-21.2-5-31.2,4.9c-10,9.9-12.2,23.8-4.9,31 C263.8,355.7,277.8,353.5,287.8,343.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.1,356.3c9.5,0,17.2-11,17.2-24.6c0-13.6-7.7-24.6-17.2-24.6c-9.5,0-17.2,11-17.2,24.6 C42,345.3,49.7,356.3,59.1,356.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M333.8,369.1c0,0,5.9-5.6,5.9,5.6c0,0,0,22.4-25.9,36.5c0,0-30.1,19.6-54.8,11.2c0,0-7.1-2.8-7.1-8.4 c0-5.6,5.9-5.6,11.7-5.6c0,0,35.1,0,52.7-16.8C316.2,391.5,322.1,385.9,333.8,369.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45.8,241.6c0,0,2.9-44.9,67.2-79.4c51-27.4,45.3-29.5,86.6-29.2c56.2,0.5,111.7,15.4,159.2,45.3 c36.5,23,72.7,57.1,93.2,107.1c0,0,52.3,99.3,5.6,181.1c0,0-40.9,52.6-64.2,52.6h-8.4c-3.3,0,23.5-11.8,45.1-73.1 c0,0,10.3-32.8-22.2-116.8c0,0-7.3-19.6-29.2-40.9c-25.6-24.9-51.7-46.9-85.1-59.3c-28.6-10.6-66-22-95.9-22.5 C197.6,206.5,110,194.9,45.8,241.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.5,201.7c0,0,59.5-141.4,168.1-29.3c0,0,34.7,7.6,18.3,33.9c0,0-16.7,17.7-34.4,1.1 c0,0-7.3-13.5,1.1-22.5c0,0-18.1-18.3-41.5-27.4c-22.6-8.8-48.4-0.3-62.2,19.8c-7.1,10.4-15.1,24.2-19.5,38.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.8,229.3c0,0,63.6-46.7,188.9-29.2c0,0,153.5,17.5,194.8,151.7c0,0,30,87.5-17.7,163.4 c0,0,76.7-70,53.1-163.4c0,0-17.6-81.7-82.6-140.1c0,0-94.7-85.6-236.1-58.4C132,156.2,105,168.9,93,176.8 C71.5,191,57.6,206,45.8,229.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M394.6,314.7c0,0-6,182.2-131.3,223.3c0,0,95.4-5.9,143.3-70.5C406.6,467.5,460.5,432.2,394.6,314.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.9316,
    y1: 432.6145,
    x2: 305.507,
    y2: 395.2336,
    gradientTransform: "matrix(1 0 0 -1 0 596.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#EB5D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F8AE3D"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M300.8,170.5c-4.9-1.6-10.9-1.1-18,1.3c-3.4,1.2-6.4,2.6-8.6,3.8c0,0,1.9,3.4,4,7.2c2.2-1.2,5.3-2.7,8.6-3.9 c6.3-2.2,9.8-1.9,11.6-1.3c7.1,2.3,11.2,8.9,9.2,14.9c-1.9,6-9.2,8.9-16.3,6.7c-0.3-0.1-0.7-0.3-1.2-0.5c1.8,1.4,3.8,2.7,5.9,3.4 c12.9,4.1,17.8-2.3,18.2-2.8c0.8-1.2,1.5-2.6,1.9-4C319.5,185.5,312.6,174.3,300.8,170.5L300.8,170.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065037025711762994930000001574558378484477346_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.2454,
    y1: 406.4619,
    x2: 234.67,
    y2: 443.8428,
    gradientTransform: "matrix(1 0 0 -1 0 596.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#E7267A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#542E84"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065037025711762994930000001574558378484477346_)"
    },
    d: "M244,191.9c4.9,1.6,10.9,1.1,18-1.3 c3.4-1.2,6.4-2.6,8.6-3.8c0,0-1.9-3.4-4-7.2c-2.2,1.2-5.3,2.7-8.6,3.9c-6.3,2.2-9.8,1.9-11.6,1.3c-7.1-2.3-11.2-9-9.2-14.9 c1.9-5.9,9.2-8.9,16.3-6.7c0.3,0.1,0.7,0.3,1.2,0.5c-1.8-1.4-3.8-2.7-5.9-3.4c-12.9-4.1-17.8,2.3-18.2,2.8c-0.8,1.2-1.5,2.6-1.9,4 C225.3,177,232.2,188.1,244,191.9L244,191.9z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M296.1,201.9c-6.5-2.3-11.9-9-13-10.6c-2.6-4.1-8.5-14.6-8.9-15.4c-4.2-7.9-10.3-17.2-18.5-19.9 c-10-3.2-20.4,0-25.2,7.1c0.4-0.5,6.1-6.8,18.1-2.7c6.5,2.3,11.9,9,13,10.6c2.6,4.1,8.5,14.6,8.9,15.4 c4.2,7.9,10.3,17.2,18.5,19.9c10,3.2,20.3,0,25.2-7.1C313.9,199.7,308.2,206,296.1,201.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.3,371.5c0,0-6.4,0-6.4,11.4c0,0,0,2.8-1.6,6.4c-2.7,6-9.1,9.9-16.3,11.1c-3.6,0.6-7.8,2-7.8,5.2 c0,5.7,0,11.4,13.4,11.4c0,0,24.1-4.9,24.8-28.4C95.8,371.5,89.4,371.5,89.3,371.5L89.3,371.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.4,254.1c11.1,13,23.4,25.6,32.6,39.6c2.4,5.1,4.3,10.4,4.5,16.6l-1.1,0.6c-11.7-6-17.7-15.3-22.3-26.1 c-5.3-9.9-10.3-20-14.8-30.1L77.4,254.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.6,266.4c-10.4,8.7-20.9,17.2-31.7,25.5c-10.5,9.2-21.6,16.7-36.3,19.1L229,310 c7.5-12.2,18.9-19.4,31.7-25.5c11.9-6.7,24.1-13,36.3-19.1L297.6,266.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlienFace);
export default __webpack_public_path__ + "static/media/Alien Face.4c986c5f531619ad97836e6bf478f7de.svg";
export { ForwardRef as ReactComponent };